export const GET_MED_REQUEST="GET_MED_REQUEST";
export const GET_MED_SUCCESS="GET_MED_SUCCESS";
export const GET_MED_ERRROR="GET_MED_ERROR";

export const ADD_MED_REQUEST="ADD_MED_REQUEST";
export const ADD_MED_SUCCESS="ADD_MED_SUCCESS";
export const ADD_MED_ERRROR="ADD_MED_ERRROR";

export const DELETE_MED_REQUEST="DELETE_MED_REQUEST";
export const DELETE_MED_SUCCESS="DELETE_MED_SUCCESS";
export const DELETE_MED_ERRROR="DELETE_MED_ERRROR";

export const UPDATE_MED_REQUEST="UPDATE_MED_REQUEST";
export const UPDATE_MED_SUCCESS="UPDATE_MED_SUCCESS";
export const UPDATE_MED_ERRROR="UPDATE_MED_ERRROR";

export const STATUS_MED_REQUEST="STATUS_MED_REQUEST";
export const STATUS_MED_SUCCESS="STATUS_MED_SUCCESS";
export const STATUS_MED_ERRROR="STATUS_MED_ERRROR";